import React from 'react';
import {
  getHeroContent, HeroImage, StoreLogo, SearchBar, CartBtn, TabContent, StoreFooter, FaHeart, getTabLabel, InlineEditableText
} from './ThemeLayoutHelpers';

export default function BloomLayout({ p }) {
  const T = p.storeTheme || {};
  const primary = T.primaryColor || "#e11d48";
  const secondary = T.secondaryColor || "#fb7185";
  const text = p.storefrontText || {};
  const copy = getHeroContent(p, {
    eyebrow: "Bloom • Beauty Collection",
    title: "Beauty that blooms with you.",
    subtitle: "Discover curated beauty essentials, skincare, and lifestyle picks handpicked for glow and grace.",
    primaryCta: "Shop Beauty",
    secondaryCta: "Our Story",
  });
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: T.backgroundColor || "#fff1f2", fontFamily: T.fontFamily || "Poppins, sans-serif" }}>
      <nav className="sticky top-0 z-40 border-b border-rose-200/70 bg-white/85 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3">
          <StoreLogo storeInfo={p.storeInfo} border="border-2 border-rose-200" />
          <div>
            <p className="text-sm font-bold text-rose-900">{p.storeInfo?.businessName}</p>
            <p className="text-[10px] text-rose-500 font-medium tracking-wide">{p.storeInfo?.businessCategory || text.storeInfo || "Store Info"}</p>
          </div>
          <SearchBar searchQuery={p.searchQuery} setSearchQuery={p.setSearchQuery} theme={T} className="flex-1 hidden md:block ml-3" />
          <div className="ml-auto flex items-center gap-2">
            <button onClick={p.handleGoToWishlist} className="relative p-2 rounded-full border border-rose-200 hover:bg-rose-50" style={{ color: primary }}>
              <FaHeart className="text-base" />
              {p.wishlistCount > 0 && <span className="absolute -top-1 -right-1 h-4 w-4 text-[9px] rounded-full text-white flex items-center justify-center" style={{ backgroundColor: primary }}>{p.wishlistCount}</span>}
            </button>
            <CartBtn p={p} />
            {p.userMenuElement}
          </div>
        </div>
      </nav>
      <section className="max-w-7xl mx-auto w-full px-4 pt-6">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.3fr] gap-5">
          <div className="rounded-3xl p-8 md:p-10 relative overflow-hidden shadow-[0_20px_60px_rgba(225,29,72,0.28)]" style={{ background: `linear-gradient(145deg, ${primary} 0%, ${secondary} 100%)` }}>
            <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-white/10" />
            <div className="absolute -left-8 bottom-0 h-32 w-32 rounded-full bg-black/10" />
            <p className="text-[10px] uppercase tracking-[0.28em] text-white/60 font-bold"><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></p>
            <h1 className="mt-4 text-4xl font-extrabold text-white leading-tight max-w-sm"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
            <p className="mt-3 text-white/75 text-sm max-w-xs"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
            <div className="mt-6 flex gap-3">
              <button onClick={() => p.setActiveTab("products")} className="px-5 py-2.5 rounded-full text-sm font-bold bg-white shadow-md" style={{ color: primary }}><InlineEditableText p={p} field="primaryCtaText" value={copy.primaryCta}>{copy.primaryCta}</InlineEditableText></button>
              <button onClick={() => p.setActiveTab("details")} className="px-5 py-2.5 rounded-full text-sm font-semibold text-white border border-white/40"><InlineEditableText p={p} field="secondaryCtaText" value={copy.secondaryCta}>{copy.secondaryCta}</InlineEditableText></button>
            </div>
          </div>
          <div className="rounded-3xl overflow-hidden shadow-[0_18px_50px_rgba(225,29,72,0.22)]">
            <HeroImage p={p} themeId="bloom" className="h-80 md:h-full min-h-[320px]">
              <div className="absolute inset-0 bg-gradient-to-t from-rose-900/60 via-rose-900/15 to-transparent pointer-events-none" />
              <div className="absolute bottom-0 inset-x-0 p-6">
                <p className="text-2xl font-extrabold text-white">{p.storeInfo?.businessCategory || p.storeInfo?.businessName}</p>
              </div>
            </HeroImage>
          </div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto w-full px-4 mt-5">
        <div className="rounded-2xl border border-rose-200 bg-white p-1.5 flex gap-1.5 overflow-x-auto">
          {[["products", getTabLabel(p, "products")],["services", getTabLabel(p, "services")],["details", getTabLabel(p, "details")]].map(([k,l]) => (
            <button key={k} onClick={() => p.setActiveTab(k)} className="px-5 py-2 rounded-xl text-sm font-semibold whitespace-nowrap transition" style={p.activeTab===k ? { backgroundColor: primary, color:"#fff" } : { color:"#9f1239" }}>{l}</button>
          ))}
        </div>
      </section>
      <section className="flex-1 max-w-7xl mx-auto w-full px-4 py-6"><TabContent p={p} /></section>
      <StoreFooter p={p} />
    </div>
  );
}

// ─── Circuit ─────────────────────────────────────────────────────────────────